import React, { useEffect, useState } from 'react';
import ServiceOverdue from './Overdue';
import UpcomingDue from './UpcomingDue';
import { factoryId } from '../../../../store/reducers/account_reducer';
import { useDispatch, useSelector } from 'react-redux';
import { removeAllBreadCrumb, setBreadCrumb } from '../../../../store/reducers/menu_reducer';
import { getAllDashboardCount, getMac } from '../../../../services/mm/apiController';
import FactoryDropdown from '../../../vm/FactoryDropdown';
import DashCountDetail from '../../../../components/atoms/DashCountDetail';

const Home = () => {
  const dispatch = useDispatch();
  const [machineCounts, setMachineCounts] = useState();
  const [scrapResell, setScrapResell] = useState();
  const [machineRequests, setMachineRequests] = useState();
  const [approvedMachine, setApprovedMachine] = useState();
  const factoryId_ = useSelector(factoryId);

  useEffect(() => {
    dispatch(removeAllBreadCrumb());
    dispatch(
      setBreadCrumb({
        label: 'Dashboard',
        value: '/home',
      })
    );
    showAllCounts();
  }, [factoryId_]);

  const showAllCounts = async () => {
    const machineAllCounts = await getAllDashboardCount(factoryId_);
    const scrapResellAll = await getAllDashboardCount(factoryId_, 'RESELL');
    const initiatedMachine = await getMac(factoryId_, 'INITIATED');
    const approvedMachineAll = await getMac(factoryId_, 'APPROVED');
    setMachineCounts(machineAllCounts.data);
    setScrapResell(scrapResellAll.data);
    setMachineRequests(initiatedMachine.data);
    setApprovedMachine(approvedMachineAll.data);
  };

  return (
    <React.Fragment>
      <p>
        <FactoryDropdown onFactoryChange={showAllCounts} />
      </p>
      <div className="dash-count-parent-wrapper">
        <VehicleRequestCount title="Active Machines" count={machineCounts} cardType="danger" />
        <VehicleCount title="Scrap/Resell Vehicle" count={scrapResell} />
        <VehicleRequestCount
          link={machineRequests ? '/mm/machine-requests?status=INITIATED' : ''}
          title="# Pending Requests"
          count={machineRequests}
          caption="Need immediate action"
          cardType="danger"
        />
        <VehicleRequestCount
          link={approvedMachine ? '/mm/machine-requests?status=APPROVED' : ''}
          title="# Pending PO(s)"
          count={approvedMachine}
          caption="Need immediate action"
          cardType="danger"
        />
      </div>
      <div className="dash-parent-wrapper">
        <DashCard>
          <UpcomingDue />
        </DashCard>
        <DashCard>
          <ServiceOverdue />
        </DashCard>
      </div>
    </React.Fragment>
  );
};

const DashCard = (props) => {
  return <div className="dash-card">{props.children}</div>;
};
const VehicleCount = ({ link, title, count, caption }) => {
  return <DashCountDetail link={link} title={title} value={count} caption={caption} />;
};

const VehicleRequestCount = ({ link, title, caption, count }) => {
  return <DashCountDetail link={link} title={title} value={count} caption={caption} />;
};

export default Home;
